import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import {
  ReadingMeetingListDTO,
  ReadingMeetingDTO,
  ReportedMeetingListDTO,
  ReportedMeetingDTO,
  ReportedMeetingSummaryDTO,
  PopularMeetingListDTO,
  PopularMeetingDTO,
} from '../dto/MeetingManagementDTOs';
import { genNoobookHeader } from './Common';

/**
 * 독서모임 목록 조회
 * @param authToken 인증 토큰
 * @param startDate 시작일 (YYYY-MM-DD, 선택)
 * @param endDate 종료일 (YYYY-MM-DD, 선택)
 * @param ageGroup 연령대별 필터 (선택)
 * @param status 상태 필터 ('all' | 'PENDING' | 'REJECTED', 선택)
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getReadingMeetingList(
  authToken: string,
  startDate?: string,
  endDate?: string,
  ageGroup?: string,
  status?: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<ReadingMeetingListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (ageGroup) params.ageGroup = ageGroup;
  if (status && status !== 'all') params.status = status;

  return ApiComm.getData<ResponseDTO<ReadingMeetingListDTO>>(
    '/admin/v1/meetings/reading',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환 (서버 API 준비 전까지 사용)
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockMeetings: ReadingMeetingDTO[] = [
        {
          meetingNo: 1,
          meetingName: '아침 독서 모임',
          hostName: '모임장',
          applicationDate: '2023-09-30',
          status: 'PENDING',
        },
        {
          meetingNo: 2,
          meetingName: '필사 웰린지',
          hostName: '모임장',
          applicationDate: '2023-09-30',
          status: 'APPROVED',
        },
      ];

      const mockData: ReadingMeetingListDTO = {
        meetings: mockMeetings,
        page: {
          current: page,
          last: 1,
          total: 2,
        },
      };

      const response: ResponseDTO<ReadingMeetingListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 신고된 모임 요약 정보 조회
 * @param authToken 인증 토큰
 */
export function getReportedMeetingSummary(
  authToken: string
): Promise<ResponseDTO<ReportedMeetingSummaryDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.getData<ResponseDTO<ReportedMeetingSummaryDTO>>(
    '/admin/v1/meetings/reported/summary',
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockData: ReportedMeetingSummaryDTO = {
        reportsReceived: 2,
        processingPending: 0,
        warningsSent: 0,
        forcedSuspension: 0,
      };

      const response: ResponseDTO<ReportedMeetingSummaryDTO> = {
        errorCode: 0,
        response: mockData,
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 신고된 모임 목록 조회
 * @param authToken 인증 토큰
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getReportedMeetingList(
  authToken: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<ReportedMeetingListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };

  return ApiComm.getData<ResponseDTO<ReportedMeetingListDTO>>(
    '/admin/v1/meetings/reported',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockMeetings: ReportedMeetingDTO[] = [
        {
          meetingNo: 1,
          meetingName: '아침 독서 모임',
          reportReason: '빅(티장 생경옥)모밀가 알아는 신고 사유',
          cumulativeReportCount: 0,
          status: 'PROCESSING',
        },
        {
          meetingNo: 2,
          meetingName: '필사 첼린지',
          reportReason: '확정(라) 타면 대응영도의 신고 사유',
          cumulativeReportCount: 0,
          status: 'COMPLETED',
        },
      ];

      const mockData: ReportedMeetingListDTO = {
        meetings: mockMeetings,
        page: {
          current: page,
          last: 1,
          total: 2,
        },
      };

      const response: ResponseDTO<ReportedMeetingListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 인기 모임 목록 조회
 * @param authToken 인증 토큰
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getPopularMeetingList(
  authToken: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<PopularMeetingListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };

  return ApiComm.getData<ResponseDTO<PopularMeetingListDTO>>(
    '/admin/v1/meetings/popular',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockMeetings: PopularMeetingDTO[] = [
        {
          rank: 1,
          meetingNo: 1,
          meetingName: '아첨 득서 모임',
          hostName: '모임장',
          memberCount: 13,
          isExposed: true,
        },
      ];

      const mockData: PopularMeetingListDTO = {
        meetings: mockMeetings,
        page: {
          current: page,
          last: 1,
          total: 1,
        },
      };

      const response: ResponseDTO<PopularMeetingListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 모임 승인
 * @param authToken 인증 토큰
 * @param meetingNo 모임 번호
 */
export function approveMeeting(
  authToken: string,
  meetingNo: number
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.postData<ResponseDTO<any>>(
    `/admin/v1/meetings/${meetingNo}/approve`,
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}

/**
 * 모임 반려
 * @param authToken 인증 토큰
 * @param meetingNo 모임 번호
 */
export function rejectMeeting(
  authToken: string,
  meetingNo: number
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.postData<ResponseDTO<any>>(
    `/admin/v1/meetings/${meetingNo}/reject`,
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}

/**
 * 모임 경고 발송
 * @param authToken 인증 토큰
 * @param meetingNo 모임 번호
 */
export function sendWarningToMeeting(
  authToken: string,
  meetingNo: number
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.postData<ResponseDTO<any>>(
    `/admin/v1/meetings/${meetingNo}/warning`,
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}

/**
 * 모임 정지
 * @param authToken 인증 토큰
 * @param meetingNo 모임 번호
 */
export function suspendMeeting(
  authToken: string,
  meetingNo: number
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.postData<ResponseDTO<any>>(
    `/admin/v1/meetings/${meetingNo}/suspend`,
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}

/**
 * 인기 모임 노출 설정 변경
 * @param authToken 인증 토큰
 * @param meetingNo 모임 번호
 * @param isExposed 노출 여부
 */
export function updatePopularMeetingExposure(
  authToken: string,
  meetingNo: number,
  isExposed: boolean
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.putData<ResponseDTO<any>>(
    `/admin/v1/meetings/popular/${meetingNo}/exposure`,
    { isExposed },
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}
